<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        用户管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <el-row :gutter="20">
      <!--部门数据-->

      <!--用户数据-->
      <el-col :span="24">
        <div class="common-page common-tool-bar">
          <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
              <el-button v-hasPermi="['system:user:add']" icon="el-icon-plus" type="primary" @click="$router.push('/power/user-add')">新增</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button v-hasPermi="['system:user:edit']" :disabled="single" icon="el-icon-edit" type="success" @click="handleUpdate">修改</el-button>
            </el-col>
            <el-col :span="1.5">
              <el-button v-hasPermi="['system:user:remove']" :disabled="multiple" icon="el-icon-delete" type="danger" @click="handleDelete">删除</el-button>
            </el-col>
            <!-- <el-col :span="1.5">
                        <el-button type="info" icon="el-icon-upload2"  @click="handleImport" v-hasPermi="['system:user:import']">导入
                        </el-button>
                    </el-col> -->
            <el-col :span="1.5">
              <el-button v-hasPermi="['system:user:export']" icon="el-icon-download" type="warning" @click="handleExport">导出</el-button>
            </el-col>
            <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
          </el-row>
        </div>
        <el-table v-loading="loading" :data="userList" border @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="50"/>
          <!-- <el-table-column label="用户编号" align="center" prop="userIdStr" /> -->
          <el-table-column :show-overflow-tooltip="true" align="center" label="用户账号" prop="userName"/>
          <el-table-column :show-overflow-tooltip="true" align="center" label="用户名称" prop="nickName"/>
          <el-table-column align="center" label="角色名称" prop="roleName"/>
          <el-table-column align="center" label="状态" width="100px">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-value="1" inactive-value="0" @change="handleStatusChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column align="center" label="创建时间" prop="createTime">
            <template slot-scope="scope">
              <span>{{ parseTime(scope.row.createTime) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" class-name="small-padding " label="操作" width="300">
            <template slot-scope="scope">
              <el-button v-hasPermi="['system:user:edit']" icon="el-icon-edit" size="mini" type="warning" @click="handleUpdate(scope.row)"> 修改</el-button>
              <el-button v-if="scope.row.userId !== 1" v-hasPermi="['system:user:remove']" icon="el-icon-delete" size="mini" type="danger" @click="handleDelete(scope.row)">
                删除
              </el-button>
              <el-button v-hasPermi="['system:user:resetPwd']" class="" icon="el-icon-key" size="mini" type="info" @click="handleResetPwd(scope.row)">重置</el-button>
              <!-- class="mt10" -->
              <el-button v-hasPermi="['system:user:resetPwd']" class="" icon="el-icon-user" size="mini" type="success" @click="handleUserId(scope.row)" @closeOnClickModal="true">
                用户编号
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :limit.sync="queryParams.pageSize" :page.sync="queryParams.pageNum" :total="total" @pagination="getList"/>
      </el-col>
    </el-row>

    <el-dialog :close-on-click-modal="false" :visible.sync="showSearch" title="查询">
      <el-form v-show="showSearch" ref="queryForm" :inline="true" :model="queryParams" class="search-con" label-width="120px">
        <el-form-item label="账号性质" prop="natureId">
          <!-- <el-input
            v-model="queryParams.natureId"
            placeholder="请输入账号性质"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          /> -->
          <el-select v-model="queryParams.natureId" :clearable="true" @keyup.enter.native="handleQuery">
            <el-option v-for="(item, index) in typeList" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户账号" prop="userName">
          <el-input v-model="queryParams.userName" :clearable="true" placeholder="请输入用户账号" size="small" @keyup.enter.native="handleQuery"/>
        </el-form-item>
        <el-form-item label="单位名称" prop="companyName">
          <el-input v-model="queryParams.companyName" :clearable="true" placeholder="请输入用户账号" size="small" @keyup.enter.native="handleQuery"/>
        </el-form-item>

        <el-form-item label="账号角色" prop="roleId">
          <!-- <el-input
            v-model="queryParams.natureId"
            placeholder="请输入账号性质"
            clearable
            size="small"
            @keyup.enter.native="handleQuery"
          /> -->
          <el-select v-model="queryParams.roleId" :clearable="true" @keyup.enter.native="handleQuery">
            <el-option v-for="(item, index) in roleList" :key="index" :label="item.roleName" :value="item.roleId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="queryParams.status" :clearable="true" placeholder="用户状态" size="small">
            <el-option v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"/>
          </el-select>
        </el-form-item>
        <div class="center">
          <el-button icon="el-icon-search" type="primary" @click="handleQuery">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </div>
      </el-form>
    </el-dialog>

    <!-- 添加或修改参数配置对话框 -->
    <el-dialog :title="title" :visible.sync="open" append-to-body width="600px">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户名称" prop="nickName">
              <el-input v-model="form.nickName" placeholder="请输入用户名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属部门" prop="deptId">
              <treeselect v-model="form.deptId" :options="deptOptions" :show-count="true" placeholder="请选择归属部门"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phonenumber">
              <el-input v-model="form.phonenumber" maxlength="11" placeholder="请输入手机号码"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" maxlength="50" placeholder="请输入邮箱"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item v-if="form.userId == undefined" label="用户账号" prop="userName">
              <el-input v-model="form.userName" placeholder="请输入用户账号"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item v-if="form.userId == undefined" label="用户密码" prop="password">
              <el-input v-model="form.password" placeholder="请输入用户密码" type="password"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="用户性别">
              <el-select v-model="form.sex" placeholder="请选择">
                <el-option v-for="dict in sexOptions" :key="dict.dictValue" :label="dict.dictLabel" :value="dict.dictValue"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-radio-group v-model="form.status">
                <el-radio v-for="dict in statusOptions" :key="dict.dictValue" :label="dict.dictValue">{{ dict.dictLabel }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="岗位">
              <el-select v-model="form.postIds" multiple placeholder="请选择">
                <el-option v-for="item in postOptions" :key="item.postId" :disabled="item.status == 1" :label="item.postName" :value="item.postId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色" prop="roleIds">
              <el-select v-model="form.roleIds" multiple placeholder="请选择">
                <el-option v-for="item in roleOptions" :key="item.roleId" :disabled="item.status == 1" :label="item.roleName" :value="item.roleId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" placeholder="请输入内容" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 用户导入对话框 -->
    <el-dialog :title="upload.title" :visible.sync="upload.open" append-to-body width="400px">
      <el-upload
          ref="upload"
          :action="upload.url + '?updateSupport=' + upload.updateSupport"
          :auto-upload="false"
          :disabled="upload.isUploading"
          :headers="upload.headers"
          :limit="1"
          :on-progress="handleFileUploadProgress"
          :on-success="handleFileSuccess"
          accept=".xlsx, .xls"
          drag
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div slot="tip" class="el-upload__tip">
          <el-checkbox v-model="upload.updateSupport"/>
          是否更新已经存在的用户数据
          <el-link style="font-size: 12px" type="info" @click="importTemplate">下载模板</el-link>
        </div>
        <div slot="tip" class="el-upload__tip" style="color: red">
          提示：仅允许导入“xls”或“xlsx”格式文件！
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitFileForm">确 定</el-button>
        <el-button @click="upload.open = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {listUser, getUser, delUser, addUser, updateUser, exportUser, resetUserPwd, changeUserStatus, importTemplate} from '@/api/system/user';
// import { getToken } from "@/utils/auth";
import db from '@/utils/localstorage'; //导入持久化缓存工具

import {treeselect} from '@/api/system/dept';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'User',
  components: {Treeselect},
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: false,
      // 总条数
      total: 0,
      // 用户表格数据
      userList: null,
      // 弹出层标题
      title: '',
      // 部门树选项
      deptOptions: undefined,
      // 是否显示弹出层
      open: false,
      // 部门名称
      deptName: undefined,
      // 默认密码
      initPassword: undefined,
      // 角色列表
      roleList: [],
      // 日期范围
      dateRange: [],
      // 状态数据字典
      statusOptions: [],
      // 性别状态字典
      sexOptions: [],
      // 岗位选项
      postOptions: [],
      // 角色选项
      roleOptions: [],
      // 表单参数
      form: {},
      // 单位类型
      typeList: [
        {name: '监管账号', value: '1'},
        {name: '接警账号', value: '4'},
        {name: '集团/园区账号', value: '3'},
        {name: '单位账号', value: '2'},
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: {Authorization: 'Bearer ' + db.get('token')},
        // 上传的地址
        url: process.env.VUE_APP_BASE_API + '/system/user/importData',
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: undefined,
        phonenumber: undefined,
        status: undefined,
        deptId: undefined,
        natureId: undefined,
        roleId: undefined,
        companyName: undefined,
      },
      // 表单校验
      rules: {
        userName: [{required: true, message: '用户账号不能为空', trigger: 'blur'}],
        nickName: [{required: true, message: '用户名称不能为空', trigger: 'blur'}],
        deptId: [{required: true, message: '归属部门不能为空', trigger: 'blur'}],
        password: [{required: true, message: '用户密码不能为空', trigger: 'blur'}],
        email: [
          //   { required: true, message: "邮箱地址不能为空", trigger: "blur" },
          {type: 'email', message: "'请输入正确的邮箱地址", trigger: ['blur', 'change']},
        ],
        phonenumber: [
          {required: true, message: '手机号码不能为空', trigger: 'blur'},
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
          },
        ],
        roleIds: [{required: true, message: '角色不能为空', trigger: 'change'}],
      },
    };
  },
  watch: {
    // 根据名称筛选部门树
    deptName(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getList();
    this.getTreeselect();
    this.getDicts('sys_normal_disable').then((response) => {
      this.statusOptions = response.data;
    });
    this.getDicts('sys_user_sex').then((response) => {
      this.sexOptions = response.data;
    });
    this.getConfigKey('sys.user.initPassword').then((response) => {
      this.initPassword = response.msg;
    });
    this.$get('/system/role/notPageList').then((res) => {
      console.log(res);
      this.roleList = res.data;
    });
  },
  methods: {
    /** 查看用户编号 */
    handleUserId(row) {
      this.$alert('编号为：' + row.userId, '用户编号', {
        confirmButtonText: '确定',
        closeOnClickModal: true,
        type: 'info',
      });
    },
    /** 查询用户列表 */
    getList() {
      this.loading = true;
      listUser(this.addDateRange(this.queryParams, this.dateRange)).then((response) => {
        this.userList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 查询部门下拉树结构 */
    getTreeselect() {
      treeselect().then((response) => {
        this.deptOptions = response.data;
      });
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 节点单击事件
    handleNodeClick(data) {
      this.queryParams.deptId = data.id;
      this.getList();
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.status === '1' ? '启用' : '停用';
      this.$confirm('确认要"' + text + '""' + row.userName + '"用户吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(function () {
            return changeUserStatus(row.userId, row.status);
          })
          .then(() => {
            // this.$message.success(text + '成功');
            this.$message({
                message: text + '成功',
                type: 'success',
                duration: 700,
              });
          })
          .catch(function () {
            row.status = row.status === '1' ? '1' : '0';
          });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        deptId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phonenumber: undefined,
        email: undefined,
        sex: undefined,
        status: '0',
        remark: undefined,
        postIds: [],
        roleIds: [],
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
      this.showSearch = false;
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.resetForm('queryForm');
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.userId);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    /** 新增按钮操作 */
    handleAdd() {
      // this.reset();
      // this.getTreeselect();
      // getUser().then(response => {
      //     this.postOptions = response.data.posts;
      //     this.roleOptions = response.data.roles;
      //     this.open = true;
      //     this.title = "添加用户";
      //     this.form.password = this.initPassword;
      // });
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      // this.reset();
      // this.getTreeselect();
      const userId = row.userId || this.ids;
      this.$router.push({
        path: '/power/user-add',
        query: {userId},
      });
      // getUser(userId).then(response => {
      //     this.form = response.data.data;
      //     this.postOptions = response.data.posts;
      //     this.roleOptions = response.data.roles;
      //     this.form.postIds = response.data.postIds;
      //     this.form.roleIds = response.data.roleIds;
      //     this.open = true;
      //     this.title = "修改用户";
      //     this.form.password = "";
      // });
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if (!value || value.trim().length < 1) {
            return '新密码不能为空';
          }
        },
        inputErrorMessage: '新密码不能为空',
      })
          .then(({value}) => {
            resetUserPwd(row.userId, value).then((response) => {
              // this.$message.success('修改成功，新密码是：' + value);
              this.$message({
                message: '修改成功，新密码是：' + value,
                type: 'success',
                duration: 700,
              });
            });
          })
          .catch(() => {
          });
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.form.userId != undefined) {
            updateUser(this.form).then((response) => {
              this.$message({
                message: '修改成功',
                type: 'success',
                duration: 700,
              });
              // this.msgSuccess('修改成功');
              this.open = false;
              this.getList();
            });
          } else {
            addUser(this.form).then((response) => {
              this.$message({
                message: '新增成功',
                type: 'success',
                duration: 700,
              });
              // this.msgSuccess('新增成功');
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const userIds = row.userId || this.ids;
      this.$confirm('是否确认删除用户编号为"' + userIds + '"的数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(function () {
            return delUser(userIds);
          })
          .then(() => {
            this.getList();
            this.msgSuccess('删除成功');
          });
    },
    /** 导出按钮操作 */
    handleExport() {
      const queryParams = this.queryParams;
      this.$confirm('是否确认导出所有用户数据项?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
          .then(function () {
            return exportUser(queryParams);
          })
          .then((response) => {
            console.log(response);
            this.download(response.msg);
          });
    },
    /** 导入按钮操作 */
    handleImport() {
      this.upload.title = '用户导入';
      this.upload.open = true;
    },
    /** 下载模板操作 */
    importTemplate() {
      importTemplate().then((response) => {
        this.download(response.msg);
      });
    },
    // 文件上传中处理
    handleFileUploadProgress(event, file, fileList) {
      this.upload.isUploading = true;
    },
    // 文件上传成功处理
    handleFileSuccess(response, file, fileList) {
      this.upload.open = false;
      this.upload.isUploading = false;
      this.$refs.upload.clearFiles();
      this.$alert(response.msg, '导入结果', {dangerouslyUseHTMLString: true});
      this.getList();
    },
    // 提交上传文件
    submitFileForm() {
      this.$refs.upload.submit();
    },
  },
};
</script>
